const EMPTY_OBJECT = {};

const getThreadsById = (threads = []) => {
  if (!Array.isArray(threads) || threads.length < 1) {
    return EMPTY_OBJECT;
  }

  const mapped = {};

  for (const thread of threads || []) {
    const threadId = String(thread?.id || '').trim();

    if (!threadId) {
      continue;
    }

    mapped[threadId] = thread;
  }

  return Object.keys(mapped).length > 0 ? mapped : EMPTY_OBJECT;
};

export default getThreadsById;
